/* eslint-disable jsx-a11y/anchor-is-valid */
import AtriumApi from "api";
import Loader from "components/loader/Loader";
import { useEffect, useState } from "react";
const Weather = () => {
  const [forecastData, setForecastData] = useState([]);
  const [church, setChurch] = useState();

  const [campuses, setCampuses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filterCampus, setFilterCampus] = useState("all");

  useEffect(() => {
    const fetchAllCampuses = async () => {
      try {
        const response = await AtriumApi.get("/v2/campuses/allCampuses");
        const campusesData = response?.data?.data?.campuses?.data || [];
        if (campusesData.length > 0) {
          setCampuses(campusesData);
          setFilterCampus(campusesData[0]);
        }
      } catch (error) {
        console.log("fetching all campuses error", error);
      }
    };
    fetchAllCampuses();
  }, []);

  useEffect(() => {
    const fetchChurch = async () => {
      try {
        const response = await AtriumApi.get("/v1/church");
        if (response) {
          setChurch(response?.data?.church);
        }
      } catch (error) {
        console.log("error fetching church", error);
      }
    };

    fetchChurch();
  }, []);

  useEffect(() => {
    if (!church) return;
    function buildWeatherQueryString() {
      // Check if a specific campus is selected
      if (filterCampus && filterCampus !== "all" && filterCampus.coordinates) {
        const [lon, lat] = filterCampus.coordinates;
        return `lat=${lat}&lon=${lon}`;
      }
      return "";
    }
    const fetchWeather = async () => {
      try {
        setLoading(true);
        const query = buildWeatherQueryString();
        const response = await AtriumApi.get(
          `/v1/weather${query ? `?${query}` : ""}`
        );
        if (response) {
          setLoading(false);
          setForecastData(response?.data);
        }
      } catch (error) {
        setLoading(false);
        console.error("Failed to fetch weather data:", error);
      }
    };

    fetchWeather();
  }, [church, filterCampus]);

  if (!forecastData) return <></>;

  return (
    <div className="flex flex-wrap justify-between rounded-[30px] p-[30px] shadow-atrium shadow-shadow-500 dark:!bg-navy-800 dark:shadow-none">
      {loading ? (
        <div className="flex items-center justify-center h-full w-full">
          <Loader />
        </div>
      ) : (
        <>
          <div className="flex items-center bg-gradient-to-b from-[#F4F7FE] to-[#FFFFFF] justify-between rounded-[20px] bg-clip-border p-[30px] font-dm dark:from-navy-900 dark:to-navy-800">
            <div className="flex-none">
              <span className=" inline-block">
                <img
                  className="w-full"
                  src={forecastData?.current?.condition?.icon}
                  alt=""
                />
              </span>
            </div>
            <div className="flex-1 pl-2 pt-[13px] pb-[13px]">
              {/* <div className="w-full rounded-xl px-3 text-md font-bold outline-none dark:text-white">{forecastData.location.name || forecastData.location.region}</div> */}
              {/* <select className="bg-[transparent] w-full rounded-xl pr-4 text-md font-bold outline-none dark:text-white">
            <option>Grapevine</option>
            <option>test</option>
            <option>Grapevine</option>
          </select> */}
              {/* <form>
            <select
              id="countries"
              className="bg-[transparent] w-full rounded-xl pr-4 text-md font-bold outline-none dark:text-white"
            >
              <option selected>Campus name</option>
              <option value="US">United States</option>
              <option value="CA">Canada</option>
              <option value="FR">France</option>
              <option value="DE">Germany</option>
            </select>
          </form> */}
              {/* <div className="relative inline-block text-left">
            <div onClick={toggleDropdown}>
              <p className="flex items-center gap-1 text-gray-700 text-base font-medium cursor-pointer">
                {selected} <MdKeyboardArrowDown />
              </p>
            </div>

            {isOpen && (
              <div className="absolute z-10 mt-2 w-40 bg-white divide-y divide-gray-100 rounded-lg shadow-sm dark:bg-gray-700 dark:divide-gray-600">
                <ul
                  className="py-2 text-sm text-gray-700 dark:text-gray-200"
                  aria-labelledby="dropdownDividerButton"
                >
                  {options.slice(0, 3).map((option) => (
                    <li key={option}>
                      <button
                        onClick={() => handleSelect(option)}
                        className="w-full text-left block px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white"
                      >
                        {option}
                      </button>
                    </li>
                  ))}
                </ul>
                <div className="py-2">
                  <button
                    onClick={() => handleSelect(options[3])}
                    className="w-full text-left block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 dark:hover:bg-gray-600 dark:text-gray-200 dark:hover:text-white"
                  >
                    {options[3]}
                  </button>
                </div>
              </div>
            )}
          </div> */}

              <div className="inline-block">
                <select
                  value={filterCampus === "all" ? "all" : filterCampus?.id}
                  onChange={(e) => {
                    const selectedId = Number(e.target.value);
                    const selectedCampus = campuses?.find(
                      (c) => c?.id === selectedId
                    );
                    setFilterCampus(selectedCampus);
                  }}
                  className="flex-none bg-[transparent] rounded-xl outline-none text-base "
                >
                  {/* <option value="all">All campuses</option> */}
                  {campuses?.length > 0 ? (
                    campuses?.map((campus) => (
                      <option key={campus?.id} value={campus?.id}>
                        {campus?.name}
                      </option>
                    ))
                  ) : (
                    <option disabled>No campus found</option>
                  )}
                </select>
              </div>

              <p className="text-sm pl-3">
                {forecastData?.current?.condition?.text}
              </p>
            </div>
            <div className="flex-none ml-[20px]">
              <p className="font-bold text-3xl">
                {parseInt(forecastData?.current?.temp_f) || ""}°F
              </p>
              <p className="text-sm text-right text-gray-700">
                {new Date().toLocaleTimeString([], {
                  hour: "2-digit",
                  minute: "2-digit",
                })}
              </p>
            </div>
          </div>

          {/* <div className="flex flex-1  pt-[6px] pb-[6px] overflow-auto ml-[30px]">
        {Array.apply(null, { length: 6 }).map((_, i) => (
          <div
            className="flex flex-col flex-1 justify-stretch text-center with-separator border-sky-500"
            key={`weather${i + 1}`}
          >
            <p>
              <span className="inline-block w-[56px]">
                <img
                  className="w-full"
                  src={
                    forecastData.forecast?.forecastday[i + 1]?.day.condition
                      .icon
                  }
                  alt=""
                />
              </span>
            </p>
            <p className="font-bold text-md">
              {parseInt(
                forecastData.forecast?.forecastday[i + 1]?.day.avgtemp_f
              ) || ""}
              °F
            </p>
            <p className="text-sm">
              {forecastData.forecast?.forecastday[i + 1]?.day.condition.text}
            </p>
            <p className="flex-1 text-sm text-gray-700 uppercase content-end">
              {i === 0
                ? "Tomorrow"
                : new Date(
                    forecastData.forecast?.forecastday[i + 1]?.date ||
                      new Date().getTime() + (i + 1) * 86400000
                  ).toLocaleDateString([], { weekday: "long" })}
            </p>
          </div>
        ))}
      </div> */}
          <div className="flex flex-1 pt-[6px] pb-[6px] md:ml-[30px] overflow-auto space-x-4">
            {Array.apply(null, { length: 6 })?.map((_, i) => (
              <div
                className={`flex w-full flex-col justify-between items-center text-center pl-4 ${
                  i !== 0 ? "border-l border-gray-300" : ""
                }`}
                key={`weather${i + 1}`}
              >
                <p>
                  <span className="inline-block w-14 h-14">
                    <img
                      className="w-full h-full object-contain"
                      src={
                        forecastData?.forecast?.forecastday[i + 1]?.day
                          ?.condition.icon
                      }
                      alt=""
                    />
                  </span>
                </p>
                <p className="font-bold text-md mt-2">
                  {parseInt(
                    forecastData?.forecast?.forecastday[i + 1]?.day?.avgtemp_f
                  ) || ""}
                  °F
                </p>
                <p className="text-sm text-gray-600">
                  {
                    forecastData?.forecast?.forecastday[i + 1]?.day?.condition
                      ?.text
                  }
                </p>
                <p className="text-sm text-gray-700 uppercase mt-1">
                  {i === 0
                    ? "Tomorrow"
                    : new Date(
                        forecastData?.forecast?.forecastday[i + 1]?.date ||
                          new Date().getTime() + (i + 1) * 86400000
                      ).toLocaleDateString([], { weekday: "long" })}
                </p>
              </div>
            ))}
          </div>
          {/* <AddCampus isOpen={isDialogOpen} onClose={handleDialogClose} />
      <ManageCampus
        isOpen={isDrawerOpen}
        onClose={() => setIsDrawerOpen(false)}
      /> */}
          {/*  */}
        </>
      )}
    </div>
  );
};

export default Weather;
